// TODO: Please remove this file after the release of the new video page.
import { TrackVideoClick } from './track_video_click';
import { MagicVariables } from '@/types';
import { RecommendationStore } from '@/stores/recommendation/recommendation';
import { VideoPageSiteData } from './types';

export class VideoPage implements MagicVariables {
    $root: MagicVariables['$root'];
    $refs: MagicVariables['$refs'];

    trackVideoClick: TrackVideoClick;
    recommendationStore: RecommendationStore;
    siteData: VideoPageSiteData;

    constructor(
        trackVideoClick: TrackVideoClick,
        recommendationStore: RecommendationStore,
        siteData: VideoPageSiteData
    ) {
        this.trackVideoClick = trackVideoClick;
        this.recommendationStore = recommendationStore;
        this.siteData = siteData;
        this.storeRecommendationID();
    }

    init() {
        this.trackVideoClick.init(this.$root, this.$refs);
    }

    storeRecommendationID() {
        this.recommendationStore.setRecommendationId(this.siteData.recommendationId);
    }
}
